import { render, staticRenderFns } from "./aweme-card.vue?vue&type=template&id=6b83b31d&scoped=true"
import script from "./aweme-card.vue?vue&type=script&lang=js"
export * from "./aweme-card.vue?vue&type=script&lang=js"
import style0 from "./aweme-card.vue?vue&type=style&index=0&id=6b83b31d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b83b31d",
  null
  
)

export default component.exports